module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin RO.10acdc43.jpg";